import {
  Box,
  Button,
  Grid,
  InputAdornment,
  Popover,
  TextField,
  Typography,
} from "@mui/material";
import { AppLayout } from "layout";
import React from "react";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";

const CategoryCommon = ({
  activeDropdown,
  setActiveDropdown,
  onCategoryChange,
  onClearAll,
}: any) => {
  const handleClick = () => {
    setActiveDropdown(2); // 2 is the index for this dropdown
  };
  const handleCategorySelection = (category: any) => {
    onCategoryChange(category);
    setActiveDropdown(null);
  };
  return (
    <Grid display={"flex"} flexDirection={"column"} position={"relative"}>
      <Box onClick={handleClick} sx={styleSheet.CategoriesContainer}>
        {/* <FormatListBulletedIcon sx={{ width: "10.13px", height: "7.88px" }} /> */}
        <img src="/assets/icons/category.png" alt="search" />
        Categories
      </Box>
      {activeDropdown == 2 && (
        <Box
          sx={{
            position: "absolute",
            top: "100%",
            zIndex: 1,
            width: { xs: "100%", md: 233 },
            bgcolor: "background.paper",
            borderRadius: "8px",
            mt: 1,
            p: 2,
          }}
        >
          <Box
            display={"flex"}
            flexDirection={"column"}
            gap={2}
            fontSize={"17px"}
            fontWeight={400}
            color={"#797979"}
          >
            {[
              "Psychotherapy",
              "Kids",
              "Older Adults",
              "Health Psychology",
              "Affirming/Anti-racist Therapy",
              "Neuropsychology",
              "Testing",
            ].map((category) => (
              <Typography
                key={category}
                onClick={() => handleCategorySelection(category)}
                sx={{ cursor: "pointer" }}
              >
                {category}
              </Typography>
            ))}

            <Box display="flex" alignItems="center" mb={2}>
              <Button
                variant="outlined"
                onClick={() => {
                  onClearAll(); // Trigger clear all
                  setActiveDropdown(null); // Close dropdown
                }}
              >
                Clear
              </Button>
            </Box>
          </Box>
        </Box>
      )}
    </Grid>
  );
};

export default CategoryCommon;

const styleSheet = {
  CategoriesContainer: {
    backgroundColor: "white",
    borderRadius: "15px",
    padding: "10px 8px",
    display: "flex",
    gap: 1,
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    fontSize: "17px",
    fontWeight: "400px",
    // width: "122px",
    width: "106px",
    color: "#233F91",
    fontFamily: "Atten Round New",
  },
};
